import { type DocumentImageMetadata } from '~/gql/graphql'

import { exists } from '../../generals'
import {
  type FigureInfo,
  figureInfoKeyLabelI18nKeyMap,
  figureInfoKeys,
} from '../figureInfo'

import { toScreenLabel } from './toScreenLabel'

/**
 * FigureInfo を DocumentImageMetadata の配列に変換します。
 * name は i18n キーで保存されます。
 *
 * @param figureInfo - 変換する FigureInfo。
 * @returns 変換された DocumentImageMetadata の配列。
 */
export function toMetadataArray(
  figureInfo: FigureInfo,
): DocumentImageMetadata[] {
  return figureInfoKeys
    .filter(
      (figureInfoKey) =>
        figureInfoKey === 'screenLabel' || exists(figureInfo[figureInfoKey]),
    )
    .map((figureInfoKey) => ({
      name: figureInfoKeyLabelI18nKeyMap[figureInfoKey],
      value: JSON.stringify(
        figureInfoKey === 'screenLabel'
          ? toScreenLabel(figureInfo)
          : figureInfo[figureInfoKey],
      ),
    }))
}
